import _regeneratorRuntime from "D:/webproject/haoyu/wms-web/WMS/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/webproject/haoyu/wms-web/WMS/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import request from "@/utils/request";
export default {
  getDeliverInfo: function getDeliverInfo(data) {
    return request({
      url: process.env.VUE_APP_API_PREFIX + "/out/deliver/getDeliverInfo",
      method: "POST",
      data: data
    });
  },
  getDispatchParcel: function getDispatchParcel(data) {
    return request({
      url: process.env.VUE_APP_API_PREFIX + "/outDespatchParcelBill/getDispatchParcel",
      method: "POST",
      data: data
    });
  },
  updateDespatchParcel: function updateDespatchParcel(data) {
    return request({
      url: process.env.VUE_APP_API_PREFIX + "/outDespatchParcelBill/updateDespatchParcel",
      method: "POST",
      data: data
    });
  },
  updateDespatchParcelDetail: function updateDespatchParcelDetail(data) {
    return request({
      url: process.env.VUE_APP_API_PREFIX + "/outDespatchParcelDetail/updateDespatchParcelDetail",
      method: "POST",
      data: data
    });
  },
  getDespatchParcelNo: function getDespatchParcelNo() {
    return request({
      url: process.env.VUE_APP_API_PREFIX + "/outDespatchParcelBill/getDespatchParcelNo",
      method: "GET"
    });
  },
  getDeliverNoByDispatch: function () {
    var _getDeliverNoByDispatch = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(data) {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", request({
              url: process.env.VUE_APP_API_PREFIX + "/outDespatchParcelBill/getDeliverNoByDispatch",
              method: "GET",
              params: data
            }));
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    function getDeliverNoByDispatch(_x) {
      return _getDeliverNoByDispatch.apply(this, arguments);
    }
    return getDeliverNoByDispatch;
  }(),
  // 新增包裹单及详情
  saveParcelBill: function saveParcelBill(data) {
    return request({
      url: process.env.VUE_APP_API_PREFIX + "/outDespatchParcelBill/saveParcelBill",
      method: "POST",
      data: data
    });
  },
  // 新增发运包裹单及详情
  saveDespatchAndDetail: function saveDespatchAndDetail(data) {
    return request({
      url: process.env.VUE_APP_API_PREFIX + "/outDespatchParcelBill/saveDespatchAndDetail",
      method: "POST",
      data: data
    });
  },
  saveReturnAndDetail: function saveReturnAndDetail(data) {
    return request({
      url: process.env.VUE_APP_API_PREFIX + "/return/saveReturnAndDetail",
      method: "POST",
      data: data
    });
  },
  saveParcelLogisticsLog: function saveParcelLogisticsLog(data) {
    return request({
      url: process.env.VUE_APP_API_PREFIX + "/outParcelLogisticsLog/saveParcelLogisticsLog",
      method: "POST",
      data: data
    });
  },
  updateDespatchDetailList: function updateDespatchDetailList(data) {
    return request({
      url: process.env.VUE_APP_API_PREFIX + "/outDespatchParcelDetail/updateDespatchDetailList",
      method: "POST",
      data: data
    });
  },
  saveReturnQualityAndDetail: function saveReturnQualityAndDetail(data) {
    return request({
      url: process.env.VUE_APP_API_PREFIX + "/returnQuality/saveReturnQualityAndDetail",
      method: "POST",
      data: data
    });
  },
  getReturnNo: function getReturnNo() {
    return request({
      url: process.env.VUE_APP_API_PREFIX + "/return/getReturnNo",
      method: "GET"
    });
  },
  getQualityTaskNo: function getQualityTaskNo() {
    return request({
      url: process.env.VUE_APP_API_PREFIX + "/returnQuality/getQualityTaskNo",
      method: "GET"
    });
  },
  getReturnQuality: function getReturnQuality(data) {
    return request({
      url: process.env.VUE_APP_API_PREFIX + "/returnQuality/getReturnQuality",
      method: "POST",
      data: data
    });
  },
  getReturnNum: function getReturnNum(data) {
    return request({
      url: process.env.VUE_APP_API_PREFIX + "/returnQualityDetail/getReturnNum",
      method: "POST",
      data: data
    });
  },
  getPassRate: function getPassRate(data) {
    return request({
      url: process.env.VUE_APP_API_PREFIX + "/returnQualityDetail/getPassRate",
      method: "POST",
      data: data
    });
  },
  updateReturnQuality: function updateReturnQuality(data) {
    return request({
      url: process.env.VUE_APP_API_PREFIX + "/returnQuality/updateReturnQuality",
      method: "POST",
      data: data
    });
  },
  updateReturnQualityDetail: function updateReturnQualityDetail(data) {
    return request({
      url: process.env.VUE_APP_API_PREFIX + "/returnQualityDetail/updateReturnQualityDetail",
      method: "POST",
      data: data
    });
  },
  getMoreReturnInfo: function getMoreReturnInfo(data) {
    return request({
      url: process.env.VUE_APP_API_PREFIX + "/returnQuality/getMoreReturnInfo",
      method: "POST",
      data: data
    });
  },
  getReturnPage: function getReturnPage(data) {
    return request({
      url: process.env.VUE_APP_API_PREFIX + "/return/getReturnPage",
      method: "POST",
      data: data
    });
  },
  getReturnChannelPage: function getReturnChannelPage(data) {
    return request({
      url: process.env.VUE_APP_API_PREFIX + "/return/getReturnChannelPage",
      method: "POST",
      data: data
    });
  },
  selectTrackTabCount: function selectTrackTabCount() {
    return request({
      url: process.env.VUE_APP_API_PREFIX + "/return/selectTrackTabCount",
      method: "POST"
    });
  },
  updateReturn: function updateReturn(data) {
    return request({
      url: process.env.VUE_APP_API_PREFIX + "/return/updateReturn",
      method: "POST",
      data: data
    });
  },
  getQualityPage: function getQualityPage(data) {
    return request({
      url: process.env.VUE_APP_API_PREFIX + "/returnQuality/getQualityPage",
      method: "POST",
      data: data
    });
  },
  getQualityPageCount: function getQualityPageCount() {
    return request({
      url: process.env.VUE_APP_API_PREFIX + "/returnQuality/getQualityPageCount",
      method: "POST"
    });
  },
  getQualityDetailPage: function getQualityDetailPage(data) {
    return request({
      url: process.env.VUE_APP_API_PREFIX + "/returnQualityDetail/getQualityDetailPage",
      method: "POST",
      data: data
    });
  },
  getReturnDetailPage: function getReturnDetailPage(data) {
    return request({
      url: process.env.VUE_APP_API_PREFIX + "/returnDetail/getReturnDetailPage",
      method: "POST",
      data: data
    });
  },
  getReturnDetailPageCount: function getReturnDetailPageCount() {
    return request({
      url: process.env.VUE_APP_API_PREFIX + "/returnDetail/getReturnDetailPageCount",
      method: "POST"
    });
  },
  getReturnDetailListPage: function getReturnDetailListPage(data) {
    return request({
      url: process.env.VUE_APP_API_PREFIX + "/returnDetail/getReturnDetailListPage",
      method: "POST",
      data: data
    });
  },
  getWorkloadPage: function getWorkloadPage(data) {
    return request({
      url: process.env.VUE_APP_API_PREFIX + "/return/getWorkloadPage",
      method: "POST",
      data: data
    });
  },
  getInReturnPage: function getInReturnPage(data) {
    return request({
      url: process.env.VUE_APP_API_PREFIX + "/inReturn/getInReturnPage",
      method: "POST",
      data: data
    });
  },
  // 查询物流公司
  getLogisticsCompany: function getLogisticsCompany() {
    return request({
      url: process.env.VUE_APP_API_PREFIX + "/logisticsCompany/queryLogisticsCompany",
      method: "POST"
    });
  },
  // 获取物流渠道
  queryAllForSelect: function queryAllForSelect() {
    return request({
      url: process.env.VUE_APP_API_PREFIX + "/bsChannel/queryAllEnable",
      method: "get"
    });
  },
  getInReturnNum: function getInReturnNum() {
    return request({
      url: process.env.VUE_APP_API_PREFIX + "/inReturn/getInReturnNum",
      method: "POST"
    });
  },
  qualityInspectionList: function qualityInspectionList(data) {
    return request({
      url: process.env.VUE_APP_API_PREFIX + "/returnQuality/qualityInspectionList",
      method: "POST",
      data: data
    });
  },
  // 跟踪信息
  queryTrackingOperation: function queryTrackingOperation(data) {
    return request({
      url: process.env.VUE_APP_API_PREFIX + "/inReturn/queryTrackingOperation",
      method: "POST",
      data: data
    });
  },
  // 弹窗显示包裹单明细或退货明细
  getReturnDetailOrPackDetail: function getReturnDetailOrPackDetail(data) {
    return request({
      url: process.env.VUE_APP_API_PREFIX + "/inReturn/getReturnDetailOrPackDetail",
      method: "POST",
      data: data
    });
  },
  //  质检交接补打接口
  getReturnInfo: function getReturnInfo(data) {
    return request({
      url: process.env.VUE_APP_API_PREFIX + "/returnQuality/getReturnInfo?returnNo=" + data,
      method: "GET"
    });
  },
  //  退件更换物流渠道
  parcelBillChangeChannel: function parcelBillChangeChannel(data) {
    return request({
      url: process.env.VUE_APP_API_PREFIX + "/outDespatchParcelBill/parcelBillChangeChannel",
      method: "post",
      data: data
    });
  },
  //  退件获取物流信息
  getDispatchParcelReceive: function getDispatchParcelReceive(data) {
    return request({
      url: process.env.VUE_APP_API_PREFIX + "/outDespatchParcelBill/getDispatchParcelReceive",
      method: "post",
      data: data
    });
  },
  //  清关退回上架
  clearRack: function clearRack(data) {
    return request({
      url: process.env.VUE_APP_API_PREFIX + "/return/clearRack",
      method: "post",
      data: data
    });
  }
};